/**
 * unsafe.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({name: "unsafe", pure: true})
export class UnsafePipe implements PipeTransform {

    constructor (protected sanitizer : DomSanitizer)
    {

    }

  public transform (value : any, delimiter : string = ", ") : any
  {
    if (value === null)
    {
      return null;
    }
    if (value === undefined)
    {
      return undefined;
    }
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/unsafe.pipe.ts